class Common {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('.js-drawer-trigger').click(function() {
      $('.js-drawer-change').toggleClass('is-active');
      scrollBan();
    })
  }
}
